/** Build an in-app path with optional tenant subdomain prefix. */
export function buildTenantPath(path: string, subdomain?: string | null): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return subdomain ? `/${subdomain}${normalized}` : normalized;
}

export const CONTAINER_DETAIL_TAB = {
  info: 0,
  wafers: 1,
  images: 2,
  notes: 3,
  audit: 4,
} as const;

export type ContainerDetailTabKey = keyof typeof CONTAINER_DETAIL_TAB;

export function parseContainerDetailTabParam(tab: string | null): number {
  if (!tab) {
    return CONTAINER_DETAIL_TAB.info;
  }
  const key = tab.toLowerCase() as ContainerDetailTabKey;
  if (key in CONTAINER_DETAIL_TAB) {
    return CONTAINER_DETAIL_TAB[key];
  }
  const asNumber = Number(tab);
  return Number.isFinite(asNumber) ? asNumber : CONTAINER_DETAIL_TAB.info;
}
